export const COMMERCE_API_BASE_URL = 'https://commerce.eduardosepassos.com';

// ai-gateway — proxies the portfolio assistant's chat requests to the Anthropic API.
export const AI_GATEWAY_BASE_URL = 'https://ai.eduardosepassos.com';

// Must match the Product.Id used when creating the "Landing Page" product
// in Commerce (see the onboarding runbook in the landing-page-checkout PR).
export const LANDING_PAGE_PRODUCT_ID = 'e0c710db-5191-496b-8006-25fab0caa264';
